import { render } from "./ReportBackBtn.vue?vue&type=template&id=00e6a09a"
import script from "./ReportBackBtn.vue?vue&type=script&lang=js"
export * from "./ReportBackBtn.vue?vue&type=script&lang=js"

import "./ReportBackBtn.vue?vue&type=style&index=0&id=00e6a09a&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__